import { reactive } from "vue";
import { api } from "../api.js";

var defaults = {
	loading: false,
	saving: false,
	error: null,
	bySide: { left: [], right: [] },
	lastFetched: null,
};

// Sort entries in bedtime order: PM (12:00–23:59) first, then AM (00:00–11:59),
// each block ascending. e.g. [22:00, 23:30, 02:00, 07:00] — tonight, then morning.
function bedtimeKey(t) {
	if (!t) { return 0; }
	var parts = t.split(":");
	var h = Number(parts[0]) || 0;
	var m = Number(parts[1]) || 0;
	var minutes = h * 60 + m;
	return minutes >= 720 ? minutes - 720 : minutes + 720;
}

function group(items) {
	var out = { left: [], right: [] };
	for (var s of items) {
		if (out[s.side]) { out[s.side].push(s); }
	}
	for (var side of ["left", "right"]) {
		out[side].sort((a, b) => bedtimeKey(a.startTime) - bedtimeKey(b.startTime));
	}
	return out;
}

var schedulesStore = {
	data: reactive({ ...defaults }),
	methods: {
		load: async function () {
			schedulesStore.data.loading = true;
			try {
				var rows = await api.get("/api/schedules");
				schedulesStore.data.bySide = group(rows);
				schedulesStore.data.lastFetched = Date.now();
				schedulesStore.data.error = null;
			} catch (e) {
				schedulesStore.data.error = e.message;
			} finally {
				schedulesStore.data.loading = false;
			}
		},
		create: async function (side, entry) {
			schedulesStore.data.saving = true;
			try {
				await api.post("/api/schedules", { ...entry, side });
				await schedulesStore.methods.load();
			} catch (e) {
				schedulesStore.data.error = e.message;
				throw e;
			} finally {
				schedulesStore.data.saving = false;
			}
		},
		update: async function (id, patch) {
			schedulesStore.data.saving = true;
			try {
				await api.put("/api/schedules/" + id, patch);
				await schedulesStore.methods.load();
			} catch (e) {
				schedulesStore.data.error = e.message;
				throw e;
			} finally {
				schedulesStore.data.saving = false;
			}
		},
		remove: async function (id) {
			schedulesStore.data.saving = true;
			try {
				await api.del("/api/schedules/" + id);
				await schedulesStore.methods.load();
			} catch (e) {
				schedulesStore.data.error = e.message;
			} finally {
				schedulesStore.data.saving = false;
			}
		},
		clearStore: function () {
			Object.assign(schedulesStore.data, { ...defaults, bySide: { left: [], right: [] } });
		},
	},
};

export default schedulesStore;
